module.exports = __webpack_public_path__ + "img/aej1n-66wvl.037.437f3b60.jpeg";